// Wire values of the `companyKinds` search parameter; all of them together mean "no kind filter".
// Their labels come from the targeting vocabulary.
export const COMPANY_KIND_VALUES = ['operating', 'general_partner', 'holding'];
export const OPERATING_ONLY = ['operating'];

export const coversAllCompanyKinds = (kinds) =>
	Array.isArray(kinds) && COMPANY_KIND_VALUES.every((kind) => kinds.includes(kind));

export const defaultCompanyKinds = (vocabulary) => (vocabulary?.operatingDefault ? OPERATING_ONLY : []);

/**
 * The `companyKinds` search parameter of a kind selection. An untouched selection (null) sends
 * nothing, so the backend applies its default to a new search; an empty selection means "no kind
 * filter" and is sent as all kinds, which keeps that default from applying.
 * @param {string[]|null|undefined} kinds
 * @returns {string[]|undefined}
 */
export const companyKindsParam = (kinds) => {
	if (!Array.isArray(kinds)) return undefined;
	return kinds.length === 0 ? [...COMPANY_KIND_VALUES] : [...kinds];
};

export const companyKindLabel = (vocabulary, kind) =>
	vocabulary?.companyKinds?.find((row) => row.value === kind)?.label ?? kind;

/**
 * Badge of a company's non-operating finding. The backend decides `isOperating`: false shows the
 * kind, true with a kind is only a suspicion (never filtered). Null when there is nothing to show.
 * @param {{isOperating?: boolean, nonOperatingRole?: string|null, operatingCompanyName?: string|null}} company
 * @param {Object|undefined} vocabulary - Targeting vocabulary (kind labels)
 * @returns {{label: string, title: string, tone: 'caution'|'neutral'}|null}
 */
export const describeNonOperatingRole = (company, vocabulary) => {
	if (!company?.nonOperatingRole) return null;
	const kindLabel = companyKindLabel(vocabulary, company.nonOperatingRole);
	const operator = company.operatingCompanyName ? ` · Operative Firma: ${company.operatingCompanyName}` : '';
	if (company.isOperating === false) return { label: kindLabel, title: `${kindLabel}${operator}`, tone: 'caution' };
	if (company.isOperating === true) {
		const label = `möglicherweise ${kindLabel}`;
		return { label, title: `${label}${operator}`, tone: 'neutral' };
	}
	return null;
};
